"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var confirmMarkAsPhishing_1 = require("./helpers/confirmMarkAsPhishing");
var createItemContextsForDeleteStoreUpdate_1 = require("./helpers/createItemContextsForDeleteStoreUpdate");
var deleteItemsStoreUpdate_1 = require("owa-mail-actions/lib/triage/deleteItemsStoreUpdate");
var filterRowKeysByExistence_1 = require("./helpers/filterRowKeysByExistence");
var getInstrumentationContextsFromTableView_1 = require("owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView");
var markItemsAsPhishingBasedOnItemIds_1 = require("./helpers/markItemsAsPhishingBasedOnItemIds");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var owa_mail_actions_1 = require("owa-mail-actions");
/**
 * mark items as phishing given the row keys
 * @param rowKeys rowKeys for the specified conversations
 * @param tableView the table view id
 * @param actionSource the action source
 */
function markItemsAsPhishingFromTable(rowKeys, tableView, actionSource) {
    // Calls a helper method to trigger the confirm dialog before processing mark as phishing
    confirmMarkAsPhishing_1.default(function () {
        markItemsAsPhishingInternal(rowKeys, tableView, actionSource);
    });
}
exports.default = markItemsAsPhishingFromTable;
/**
 * mark items as phishing internal handler
 * @param rowKeys rowKeys for the specified conversations
 * @param tableView the table view id
 * @param actionSource the action source
 */
function markItemsAsPhishingInternal(rowKeys, tableView, actionSource) {
    // Since rows may have been deleted from the table while the confirm dialog was open,
    // we need to validate the rows exist before proceeding
    var filteredRowKeys = filterRowKeysByExistence_1.default(rowKeys, tableView);
    if (filteredRowKeys.length == 0) {
        // Nothing to remove
        return;
    }
    var instrumentationContexts = getInstrumentationContextsFromTableView_1.default(rowKeys, tableView);
    // Get the de-duped item ids from the row keys
    var itemIds = owa_mail_list_store_1.getRowIdsFromRowKeys(filteredRowKeys, tableView.id);
    markItemsAsPhishingBasedOnItemIds_1.default(itemIds, actionSource, function () {
        var itemContexts = createItemContextsForDeleteStoreUpdate_1.default(itemIds);
        // Dispatch action to update the store state
        deleteItemsStoreUpdate_1.default(itemContexts, tableView.tableQuery.folderId);
    });
    owa_mail_actions_1.userMailInteractionAction('MarkAsPhishing', instrumentationContexts);
}
//# sourceMappingURL=markItemsAsPhishingFromTable.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/markItemsAsPhishingFromTable.js
// module id = 5614
// module chunks = 62